// Der Code in dieser Datei lädt auf allen Seiten deiner Website

$w.onReady(function () {Write});
